import axios from 'axios'
import errorHandler from './error-handler'

export default {
  async current () {
    return axios.get('/api/users').then(r => r.data).catch(errorHandler)
  },
  async getById (userId) {
    return axios.get(`/api/users/${userId}`).then(r => r.data).catch(errorHandler)
  },
  async getByAccountId (accountId) {
    return axios.get(`/api/users/account/${accountId}`).then(r => r.data)
  },
  async uploadProfileImage (file) {
    const formData = new FormData()
    formData.append('image', file)
    return axios.post('/api/users/image', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(r => r.data).catch(errorHandler)
  },
  async uploadCoverImage (file) {
    const formData = new FormData()
    formData.append('image', file)
    return axios.post('/api/users/cover', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(r => r.data).catch(errorHandler)
  },
  async updateUser (data) {
    return axios.put('/api/users', data).then(r => r.data).catch(errorHandler)
  },
  async getStatus (id) {
    return axios.get(`/api/users/${id}/status`).then(r => r.data).catch(errorHandler)
  },
  async createOrUpdateSocialProfiles (data) {
    return axios.post('/api/users/external-profiles', data).then(r => r.data).catch(errorHandler)
  },
  async getSocialProfiles (userId) {
    return axios.get(`/api/users/external-profiles/${userId}`).then(r => r.data).catch(errorHandler)
  },
  async getCurrentUserEmail () {
    return axios.get('/api/users/email').then(r => r.data).catch(errorHandler)
  }
}



// WEBPACK FOOTER //
// ./src/api/users.js